import { authedJson } from '../http';

export interface SimulateRequest {
  action: 'buy' | 'sell';
  symbol: string;
  amount_usd: number;
}
export interface BeforeAfter {
  before: number | null;
  after: number | null;
}
export interface SimulateResponse {
  verdict: 'PASS' | 'BLOCKED';
  breaches: string[];
  deltas: {
    es_pct: BeforeAfter;
    theme_pct: { theme: string | null; before: number; after: number; limit: number };
    effective_n: BeforeAfter;
    position_policy: { limit: number | null; resulting: number };
  };
  suggested_alternative_usd: number | null;
  flags: string[];
}
export function simulate(body: SimulateRequest): Promise<SimulateResponse> {
  return authedJson('POST', '/api/v1/portfolio/simulate', body);
}
